import { render, staticRenderFns } from "./startseite-software-3.vue?vue&type=template&id=5e14d9d3&"
import script from "./startseite-software-3.vue?vue&type=script&lang=js&"
export * from "./startseite-software-3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports